import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/src/app/basket/layout/layout.jsx");
